import { REGEX_PASSWORD } from "./helpers/validationRegex";

export const passwordValidation = (value: string): boolean => {
  if (!value) return true;
  return REGEX_PASSWORD.test(value);
};
